import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useTranslation } from '../../../contexts/translation-context';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const MlaApartmentWUT = props => {
  const fieldType = FIELD_TYPES.MLA_APARTMENT;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    fieldType: fieldType
    // TODO: add label to locale-dataset.addressParts.default.apartment
    ,
    label: t('field.mla-apartment.label')
  }));
};
//# sourceMappingURL=mla-apartment-wut.js.map